import dashboard2APIsService from "../dashboard2APIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard2Data = createDataHook(
  dashboard2APIsService,
  (filters, params, controller, apiService = dashboard2APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchUsersComplianceTrendData: () =>
      apiService.fetchUsersComplianceTrendData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
    fetchMonthlyActiveUsersData: () =>
      apiService.fetchMonthlyActiveUsersData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchMostLeastCompliantUsersData: () =>
      apiService.fetchMostLeastCompliantUsersData(
        { ...params, sortBy: "name", sortOrder: "asc" },
        controller.signal
      ),
    fetchUsersByCourseAndCompletionData: () =>
      apiService.fetchUsersByCourseAndCompletionData(
        { ...params, sortBy: "name", sortOrder: "asc" },
        controller.signal
      ),
  }),
  { preflight: "shared" }
);

export default useFetchDashboard2Data;
